import React, { useState, Fragment } from 'react';
import '../../../styles/css/Attribute.css';
import { Row, Col } from 'react-bootstrap';
import { Checkbox } from '@mui/material';
import { filterAttributeStatuses } from './attribute-utils';
import { attributeTypes } from '../../../utils/search';
import FilterContainer from './FilterContainer/FilterContainer';

const AttributeItem = (props) => {
  const {
      state,
      setState,
      t,
      radioButtons,
      enums,
      setOpenedFilter,
      openedFilter,
    } = props || {},
    { attribute } = state || {},
    { Placeholders } = t || {};

  const filterAttributes = filterAttributeStatuses(enums, attribute) || null;

  const [checked, setChecked] = useState(
    state?.firstCriteria === enums.IS_TRUE.value
  );

  const changeState = (propName, value) => {
    setState((prevState) =>
      prevState?.map((item) => {
        if (item?.attribute?.label === attribute?.label) {
          return { ...item, [propName]: value };
        } else {
          return item;
        }
      })
    );
  };

  const onChangeChecked = () => {
    setChecked(!checked);
    let checkedValue = checked ? 1 : 0;
    changeState('firstCriteria', filterAttributes[checkedValue]);
  };

  const removeChosenAttribute = () => {
    setState((prevState) =>
      prevState.filter((item) => item?.attribute?.label !== attribute?.label)
    );
  };

  const notBoolean = attribute?.type !== attributeTypes.BOOLEAN;
  const colStyle = notBoolean ? 3 : 2;

  return (
    <Row className="row-attribute px-3 mb-1" key={attribute?.key}>
      <Col
        md={colStyle}
        className="d-flex attribute-item-label align-items-center"
      >
        <label>{attribute?.label}</label>
      </Col>
      {notBoolean && (
        <FilterContainer
          key={attribute?.label}
          Placeholders={Placeholders}
          attribute={attribute}
          filterAttributes={filterAttributes}
          state={state}
          changeState={changeState}
          enums={enums}
          radioButtons={radioButtons}
          removeChosenAttribute={removeChosenAttribute}
          setOpenedFilter={setOpenedFilter}
          openedFilter={openedFilter}
          t={t}
        />
      )}
      {!notBoolean && (
        <Fragment>
          <Col md={3} />
          <Col md={7} className="mb-19 d-flex pr-none justify-content-between">
            <Checkbox
              key={attribute?.label}
              className={`text-left boolean-check-box`}
              checked={checked}
              name={state?.attribute?.label}
              onChange={onChangeChecked}
              color="primary"
              required={true}
            />
            <div onClick={removeChosenAttribute}>
              <i className="fa-solid fa-xmark cursor-pointer pt-5" />
            </div>
          </Col>
        </Fragment>
      )}
    </Row>
  );
};

export default AttributeItem;
